module.exports = __webpack_public_path__ + "img/ios_bro.ea1f7d87.png";